import { EventBus } from "@/services/eventBus";
import { ApplicationEvents } from "@/events/ApplicationEvents";
import User from "@/models/User";
import { SnackbarProgrammatic } from "buefy";
import moment from "moment";
import { ACCOUNT_EXPIRATION_THRESHOLD_DAYS } from "@/config/app";

EventBus.$on(ApplicationEvents.UserAvailable, (user: User) => {
  if (user.expires_at) {
    const diffDays = Math.ceil(
      moment(user.expires_at).diff(moment(), "days", true)
    );

    if (diffDays <= ACCOUNT_EXPIRATION_THRESHOLD_DAYS) {
      SnackbarProgrammatic.open({
        message: `Your account will expire in ${diffDays} days. Contact your administrator.`,
        indefinite: true,
      });
    }
  }
});
